import { useState, useEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Box, RadioButtonGroup, Text, ResponsiveContext, Image, grommet, Grommet } from "grommet";
import NewEvaluation from "./NewEvaluation";
import { calculateHeight } from "../Utils/Utils";
import { useFetch } from "use-http";
import ExistingEvaluation from "./ExistingEvaluation";
import HomePageNav from "../Base components/HomePageNav";
import { deepMerge } from "grommet/utils";

const customTheme = deepMerge(grommet, {
    global: {
        colors: {
            brand: 'neutral-3',
            text: "neutral-3",
            border: "neutral-3",
            selected: "light-4",
        }, 
  
    },
    textInput: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        cursor: ${"pointer"};
                    }
                    `;
            }
        }
    },
    box: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        cursor: ${"pointer"};
                    }
                    `;
            }
        }
    },
    radioInput: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        accent-color: yellow;
                    }
                    `;
            }
        }
    },    
    radio: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        background-color: yellow;
                        transform: 'scale(1.8)';
                    }
                    `;
            }
        }
    }, 
    radioButton: {
        hover: {
            border: {
                color: '#6FFFB0',
           },
        },
        border: {
            width: '2px',
            color: "brand",
        },
        // extend: 
        //     {color: "red", background: "red",               
        // },
        size: '20px', // affects the size of the outer circle
    }        
});

const EvaluationSheet = () => {
    const { state } = useLocation();  
    const fromAnotherScreen = useRef(state.fromAnotherScreen);
    const options = ["Seedlings", "Stations"];

    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getinitialChosenOptionState = () => {
        if (fromAnotherScreen.current) {
            return state.chosenOption;
        }
        else{
            return "Seedlings";                     
        }
    };    
    const [chosenOption, setChosenOption] = useState(getinitialChosenOptionState()); // for Seedlings/Stations RadioButtonGroup

    // size of screen: small - mobile, medium ipad, large - computer
    const screenSize = useContext(ResponsiveContext);

    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getinitialSeedlingYearState = () => {
        if (fromAnotherScreen.current) {
            return state.seedlingYear;
        }
        else{
            return "";                     
        }
    };
    const [seedlingYear, setSeedlingYear] = useState(getinitialSeedlingYearState()); // a input field that allows to get seedlings by a specific year
    //console.log('seedlingYear', seedlingYear);

    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getinitialSeedlingIdState = () => {
        if (fromAnotherScreen.current) {
            return state.seedlingId;
        }
        else{
            return "";                     
        }
     };
    const [seedlingId, setSeedlingId] = useState(getinitialSeedlingIdState());

    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getinitialPlantState = () => {
        // console.log('In EvaluationSheet state.plantInfo >> ', state.plantInfo);
        if (fromAnotherScreen.current) {
            return{
                Id: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.Id,
                SID: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.SID,   // can be seedling_id or scion_id. 
                SUID: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.SUID, // SID-row-column
                Row: state.plantInfo === undefined || state.plantInfo === null ? 0 : state.plantInfo.Row,
                Column: state.plantInfo === undefined || state.plantInfo === null ? 0 : state.plantInfo.Column,
                MotherID: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.MotherID,
                MotherName: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.MotherName,
                FatherID: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.FatherID,
                FatherName: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.FatherName,
                StatusID: state.plantInfo === undefined || state.plantInfo === null ? 0 : state.plantInfo.StatusID,
                Year: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.Year,
                Rootstock: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.Rootstock,
                PrevID: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.Id,  // not relevant now because a new seedling is not created from another, instead a new evaluation is created with the next year
                IsSeedling: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.IsSeedling,
                IsSeeded: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.IsSeeded,
                UprootedAt: state.plantInfo === undefined || state.plantInfo === null ? null : state.plantInfo.UprootedAt
            };
        }
        else{
            return {
                Id: null,
                SID: null,   // can be seedling_id or scion_id. 
                SUID: null,  // SID-row-column
                Row: 0,
                Column: 0,
                MotherID: null,
                MotherName: null,
                FatherID: null,
                FatherName: null,
                StatusID: 0,
                Year: null,
                Rootstock: null,
                PrevID: null,
                IsSeedling: null,
                IsSeeded: null ,
                UprootedAt: null          
            };
        }
    };
    const [plantInfo, setPlantInfo] = useState(getinitialPlantState);

    // console.log('--------  plantInfo  ---------------', plantInfo);
    

    // // if we come from another screen by 'navigate', 
    // // then we enter in the condition of "if",
    // //  otherwise we enter in "else"
    // const getinitialNewExistState = () => {
    //     if (fromAnotherScreen.current) {
    //         return state.newExist;
    //     }
    //     else{
    //         return isNewOptions[0].value;                     
    //     }
    // };
        
    // const [newExist, setNewExist] = useState(getinitialNewExistState());
    
 

    // console.log(' Evaluation sheet > chosenOption >> ', chosenOption);
    return (
        <Grommet theme={customTheme} > 
            <Box 
                maxWidth="100%"
                background={{color: "#ffffff"}}
                alignSelf="center"
                >
                <Box  flex fill="vertical"
                    style={{ 
                        position: 'fixed',
                        top: 0,
                        zIndex: 10,
                        height: calculateHeight(5)
                    }}
                    >

                      <Box justify="center">  {/*Center content vertically  */}
                        <HomePageNav/>
                    </Box>              
                </Box>
                <Box >
                    <Box width="98%" margin="0 auto" style={{ height:"40px", minHeight:"40px"}}>
                        <Box style={{position:"relative"}}>
                            <Box background="neutral-3" pad={{vertical: "small"}} margin={{vertical: "xxsmall"}} >
                                <Box direction="row" justify="center" align="center">
                                    <Text size="large" weight="bold" color="#ffffff" > Vineyards </Text>
                                </Box>              
                            </Box>  
                            <Box
                                width={{ 
                                    "xsmall": "60px",
                                    "small": "90px",
                                    "medium": "90px",
                                    "large": "120px",
                                    "xlarge": "120px"
                                    }[screenSize] || "120px"} // Default to "120px" if screenSize is not matched 
                                height={{ 
                                    "xsmall": "60px",
                                    "small": "90px",
                                    "medium": "90px",
                                    "large": "120px",
                                    "xlarge": "120px"
                                    }[screenSize] || "120px"} // Default to "120px" if screenSize is not matched
                                style={{ position: "absolute", right: "3%", top: "10px" }}
                                >
                                    <Image
                                        fit="contain"
                                        src="Grape.png"                               
                                    />
                            </Box>                        
                        </Box>      
                    </Box>

                    <Box  alignSelf="center">
                            <ExistingEvaluation plantInfo={plantInfo} setPlantInfo={setPlantInfo} 
                                seedlingId={seedlingId} setSeedlingId={setSeedlingId}
                                seedlingYear={seedlingYear} setSeedlingYear={setSeedlingYear}
                                chosenOption={chosenOption} setChosenOption={setChosenOption} options={options}
                                />
                    </Box>
                </Box>
            </Box>  
        </Grommet>      
    );
};

export default EvaluationSheet;
